export const lightThemeBg = require("../assets/lightBg.png");
export const darkThemeBg = require("../assets/darkBg.png");
export const view=require('../assets/view_.svg')
export const darkView=require('../assets/dark_view.svg')